import React, { useEffect, useRef } from "react"
import "./CalendarSection.css"

const CalendarSection = () => {
  const iframeRef = useRef(null)

  useEffect(() => {
    const scriptId = "ghl-form-embed"
    let script = document.getElementById(scriptId)

    const onScriptLoad = () => {
      script?.setAttribute("data-loaded", "true")
    }

    if (!script) {
      script = document.createElement("script")
      script.id = scriptId
      script.src = "https://link.msgsndr.com/js/form_embed.js"
      script.type = "text/javascript"
      script.async = true
      script.onload = onScriptLoad
      document.body.appendChild(script)
    } else if (
      script.getAttribute("data-loaded") === "true" ||
      script.readyState === "complete"
    ) {
      // Script already loaded
    } else {
      script.addEventListener("load", onScriptLoad, { once: true })
    }

    return () => {
      script?.removeEventListener("load", onScriptLoad)
    }
  }, [])

  return (
    <section id='booking-form' className='calendar-booking-section'>
      <div className='container'>
        <div className='calendar-header'>
          <h2 className='calendar-title'>Free Walkthrough Call</h2>
        </div>
        <iframe
          ref={iframeRef}
          src='https://api.leadconnectorhq.com/widget/booking/1610lhqQl3IwdSXMieZG'
          title='Cordova consultation scheduling widget'
          style={{
            width: "100%",
            border: "none",
            overflow: "hidden",
          }}
          scrolling='no'
          id='1610lhqQl3IwdSXMieZG_1769101965316'
          loading='lazy'
        ></iframe>
      </div>
    </section>
  )
}

export default CalendarSection
